import { render, staticRenderFns } from "./ComixLoadingDiv.vue?vue&type=template&id=3ab4e1e7&scoped=true&"
var script = {}
import style0 from "./ComixLoadingDiv.vue?vue&type=style&index=0&id=3ab4e1e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab4e1e7",
  null
  
)

export default component.exports